import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchAllPages ({ commit }) {
      await platformAction({
        client: this.$api.content.staticPages,
        method: 'getAll',
        commit,
        logError: this.$logError,
        include: []
      })
    },
    async fetchPage ({ commit, getters }, id) {
      if (getters.getPageBody(id)) return
      await platformAction({
        client: this.$api.content.staticPages,
        method: 'get',
        params: id,
        commit,
        logError: this.$logError,
        include: []
      })
    }
  },
  getters: {
    ...platformGetters,
    getPageBody: s => id => s.data[id] ? s.data[id].body : null
  },

  mutations: {
    ...platformMutations
  }
}
